module.exports = __webpack_public_path__ + "static/media/tick.ab453ea3.png";